/**
 * Created by Ning Jiang on 2021-06-28.
 */

import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {DevilsCrossRoad} from "../../DevilsCrossRoad";
import {
    SimplePresentation, SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {LocalPresentation} from "../../../core/winpresentation/LocalPresentation";
import {FreespinIntro} from "../../runnerpresentations/freespin/FreespinIntro";
import {ActivateFsAnimations} from "../../runnerpresentations/freespin/ActivateFsAnimations";

export class DevilsCrossRoadFreespinIdlePresentation implements FlowStatePresentation {

    constructor() {}


    start(flowStateController:FlowStateController):void {
        const presentations:SimplePresentation[] = [
            new FreespinIntro(),
            new ActivateFsAnimations(),
            new LocalPresentation((controller:SimplePresentationRunnerController) => this.doFreeSpinZeroBet(controller), ()=>{return true}, "doFreeSpinZeroBet")
        ];

        SimplePresentationRunner.run(presentations, () => flowStateController.finish(), (callback?:Function) => flowStateController.setSkipCallback(callback), "Fs intro runner ");

    }

    private doFreeSpinZeroBet(controller:SimplePresentationRunnerController) {
        DevilsCrossRoad.apiPlugin.betHandler.zeroBet();
        DevilsCrossRoad.keypadPlugin.setZeroBetSpinCounter(DevilsCrossRoad.model.data.freespinsLeft-1);
        DevilsCrossRoad.freespinUnlockAreas.setIndicator(DevilsCrossRoad.model.data.freespinsLeft-1);
        DevilsCrossRoad.freespinUnlockAreas.resetSpinsFullCounter();

        controller.finish();
    }

    /*public async start(flowStateController:FlowStateController) {
        if(DevilsCrossRoad.model.isRestore) {
            await new Promise<void>(resolve => {
                DevilsCrossRoad.freespinIntro.show(resolve);
            });
            SlotGame.keypadPlugin.setZeroBetSpinCounter(DevilsCrossRoad.model.gameData.freespinsLeft - 1);
        } else {
            SlotGame.keypadPlugin.setZeroBetSpinCounter(DevilsCrossRoad.model.gameData.freespinsLeft - 1);
        }

        SlotGame.apiPlugin.betHandler.zeroBet();
        flowStateController.finish();
    }*/
}